import { Employee } from "../../../../contexts/interfaces";
import classes from "./MainResultsTableWaiting.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useRoutesContext } from "../../../../contexts/RoutesContext";
import { convertDate } from "../../../../utils/convertDate";

interface Props {
  forms: Employee[];
  selectedFilter: string;
  selectedUnitId: number;
  searchEmployeeId: number | undefined;
}

// This component will show forms that are waiting for more data OR doctor approval (depending on props and usage)
const MainResultsTableWaiting = ({
  forms,
  selectedFilter,
  selectedUnitId,
  searchEmployeeId,
}: Props) => {
  const { t } = useTranslation();

  const { routes } = useRoutesContext();

  const navigate = useNavigate();

  return (
    <table className={classes.table}>
      <tbody>
        <tr>
          <th>{t("mainResultsTable.permitsValidUntil")}</th>
          <th>{t("mainResultsTable.name")}</th>
          <th>{t("mainResultsTableWaiting.status")}</th>
        </tr>
        {/* Go through every employee from resultsArray and render new row into the table */}
        {forms &&
        forms.length > 0 &&
        (searchEmployeeId
          ? forms.filter((form) => form.employeeId === searchEmployeeId)
              .length > 0
          : true) ? (
          forms.map((employee, i) => {
            return (
              <tr
                key={i}
                className={classes.tableEmployeeRow}
                onClick={() =>
                  navigate(
                    `/${routes.profile}/${selectedUnitId}/${employee.employeeId}`
                  )
                }
              >
                <td>{convertDate(employee.permitsValidUntil) || "N/A"}</td>
                <td className={classes.employeeNameCell}>
                  <div className={classes.employeeName}>
                    {employee.firstName}, {employee.lastName}
                  </div>
                  {employee.jobTitle && (
                    <div className={classes.employeeJobTitle}>
                      {employee.jobTitle}
                    </div>
                  )}
                </td>

                <td>
                  {selectedFilter === "waitingForms"
                    ? t("mainResultsTableWaiting.waitingFormsForApproval")
                    : t("mainResultsTableWaiting.waitingFormsForMoreData")}
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td>
              <div className={classes.noResultsText}>
                {`${t("mainResultsTable.noResultsText")}${
                  searchEmployeeId ? t("mainResultsTable.searchIsActive") : ""
                }`}
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default MainResultsTableWaiting;
